import { render, staticRenderFns } from "./CrmClienteDetail.vue?vue&type=template&id=03e2835f&scoped=true&"
import script from "./CrmClienteDetail.vue?vue&type=script&lang=js&"
export * from "./CrmClienteDetail.vue?vue&type=script&lang=js&"
import style0 from "./CrmClienteDetail.vue?vue&type=style&index=0&id=03e2835f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e2835f",
  null
  
)

export default component.exports